import {
  Box,
  Button,
  Divider,
  Grid2,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuItemMui from "@mui/material/MenuItem";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { Add, Delete } from "@mui/icons-material";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const RCCFenceReportDetails = ({ mainData, setMainData, isNonMobile }) => {
  // console.log("lab test data-", mainData);

  const handleDateOfTest = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfTest: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  const handleFieldUpdate = (serialNo, field, value) => {
    setMainData((prev) => ({
      ...prev,
      labTestsDataFromSubs: prev.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo ? { ...test, [field]: value } : test,
      ),
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        display="grid"
        gap={0.5}
        alignItems="center"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 6",
          },
        }}
      >
        <DemoContainer
          alignContent="center"
          components={["DatePicker"]}
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          <Box style={{ width: "190px" }}>
            <DatePicker
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: "40px",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                },
              }}
              label="Date of test"
              timezone="Asia/Colombo"
              format="YYYY-MM-DD"
              // error={errorCheck.dateOfTest.error}
              value={
                mainData.dateOfTest
                  ? dayjs(mainData.dateOfTest).tz("Asia/Colombo", true)
                  : dayjs().tz("Asia/Colombo", true)
              }
              onChange={(newVal) => {
                const colomboTime = newVal?.tz("Asia/Colombo", true);
                handleDateOfTest(colomboTime);
              }}
            />
          </Box>
        </DemoContainer>
      </Box>
      <Divider sx={{ margin: "5px 0px 5px 0" }} />

      <Box justifyItems="center">
        <Paper variant="elevation" elevation={2} sx={{ padding: "20px" }}>
          {mainData.labTestsDataFromSubs?.map((data, index) => (
            <Box
              display="grid"
              gap={0.5}
              alignItems="center"
              gridTemplateColumns="repeat(9, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 9",
                },
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                sx={{ gridColumn: "span 1" }}
              >
                <Typography variant="subtitle1" color="info" textAlign="center">
                  POST NO
                </Typography>

                <Typography variant="h5" textAlign="center">
                  {data.serialNo === undefined
                    ? "AUTO"
                    : String(data.serialNo).padStart(3, "0")}
                </Typography>
              </Box>

              <TextField
                value={data.weight}
                fullWidth
                variant="outlined"
                label="Top Area (mm²)"
                onChange={(e) =>
                  handleFieldUpdate(data.serialNo, "weight", e.target.value)
                }
                type="number"
                size="small"
                sx={{
                  "& input": { textAlign: "right" },
                  gridColumn: "span 1",
                }}
              />

              <TextField
                value={data.compressiveStrength}
                fullWidth
                variant="outlined"
                label="Bottom Area (mm²)"
                onChange={(e) =>
                  handleFieldUpdate(
                    data.serialNo,
                    "compressiveStrength",
                    e.target.value,
                  )
                }
                type="number"
                size="small"
                sx={{
                  "& input": {
                    textAlign: "right",
                  },
                  gridColumn: "span 1",
                }}
              />

              <TextField
                value={data.layerThickness}
                fullWidth
                variant="outlined"
                label="Height (mm)"
                onChange={(e) =>
                  handleFieldUpdate(
                    data.serialNo,
                    "layerThickness",
                    e.target.value,
                  )
                }
                type="number"
                size="small"
                sx={{
                  "& input": {
                    textAlign: "right",
                  },
                  gridColumn: "span 1",
                }}
              />

              <TextField
                value={data.mc}
                fullWidth
                variant="outlined"
                label="Reinforcements Ø (mm)"
                onChange={(e) =>
                  handleFieldUpdate(data.serialNo, "mc", e.target.value)
                }
                type="number"
                size="small"
                sx={{
                  "& input": {
                    textAlign: "right",
                  },
                  gridColumn: "span 1",
                }}
              />

              <TextField
                value={data.mdd}
                fullWidth
                variant="outlined"
                label="No. of Bars"
                onChange={(e) =>
                  handleFieldUpdate(data.serialNo, "mdd", e.target.value)
                }
                type="number"
                size="small"
                sx={{
                  "& input": {
                    textAlign: "right",
                  },
                  gridColumn: "span 1",
                }}
              />

              <TextField
                value={data.omc}
                fullWidth
                variant="outlined"
                label="Stirrup  Ø  (mm)"
                onChange={(e) =>
                  handleFieldUpdate(data.serialNo, "omc", e.target.value)
                }
                type="number"
                size="small"
                sx={{
                  "& input": {
                    textAlign: "right",
                  },
                  gridColumn: "span 1",
                }}
              />

              <TextField
                value={data.cum}
                fullWidth
                variant="outlined"
                label="No of Stirrups"
                type="number"
                size="small"
                onChange={(e) =>
                  handleFieldUpdate(data.serialNo, "cum", e.target.value)
                }
                sx={{
                  "& input": {
                    textAlign: "right",
                  },
                  gridColumn: "span 1",
                }}
              />

              <TextField
                value={data.passing}
                fullWidth
                variant="outlined"
                label="NDT Result (N/mm²)"
                onChange={(e) =>
                  handleFieldUpdate(data.serialNo, "passing", e.target.value)
                }
                type="number"
                size="small"
                sx={{
                  "& input": {
                    textAlign: "right",
                  },
                  gridColumn: "span 1",
                }}
              />
            </Box>
          ))}
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default RCCFenceReportDetails;
